import { render } from "./StartTestPanel.vue?vue&type=template&id=61f334ce&scoped=true&ts=true"
import script from "./StartTestPanel.vue?vue&type=script&lang=ts"
export * from "./StartTestPanel.vue?vue&type=script&lang=ts"

import "./StartTestPanel.vue?vue&type=style&index=0&id=61f334ce&scoped=true&lang=css"

import exportComponent from "/home/runner/work/qti-player/qti-player/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f334ce"]])

export default __exports__